const Divider = () => {
  return (
    <div aria-hidden="true" className="w-full my-6 border-t border-gray-200" />
  );
};

export default Divider;
